import usersService from '../api';

import { 
  SET_USERS, 
  SET_EXECUTORS, 
  SET_USERS_PAGINATION_AMOUNT,
  SET_SELECTED_USER,
  SET_USERS_LIMIT
} from './users.constants';
import { User, Executor } from '@entities/dtos';
import { userGetUserTC, userSetCurrentUserAC } from '@entities/user/model/user.actions';

/*
 * get csrf token to cookeies
 * get tokens
 **/
export const usersGetUsersTC = (params, userAssetId) => {
  return async (dispatch) => {
    try {
      const data = await usersService.getUsers(params);

      if (!data) {
        return;
      }

      let { rows, count } = data.data; // rows, count
      const usersDTO = rows.map(item=> new User(item));

      if (!count) {
        count = 1;
      }

      dispatch(usersSetUsersAC(usersDTO));
      dispatch(setUsersPaginationAmountAC(count))

      if (!userAssetId && usersDTO?.length) {
        dispatch(userGetUserTC(usersDTO[0].id))
      }

    } catch (e) {
      console.log('[Error]', e);
    }
  };
};


export const usersUpdateLocalUserTC = (user) => {
  return async (dispatch) => {
    try {

      const userAssetId = new URLSearchParams(window.location.search).get("user_asset_id");

      dispatch(usersGetUsersTC(window.location.search, userAssetId));

      if (user?.id === +userAssetId) dispatch(userSetCurrentUserAC(user));

    } catch (e) {
      console.log('[Error]', e);
    }
  };
};

export const usersGetExecutorsTC = () => {
  return async (dispatch) => {
    try {
      const { data } = await usersService.getExecutors();

      if (!data) {
        return;
      }

      let executorKeys = {};

      data.forEach((executor) => {
        const modelExecutor = new Executor(executor);

        executorKeys[modelExecutor.id] = modelExecutor;
      });

      dispatch(setExecutorsAC(executorKeys));
    } catch (error) {}
  };
};

export const usersSetUsersAC = (payload) => {
  return {
    type: SET_USERS,
    payload,
  };
};

export const setExecutorsAC = (payload) => {
  return {
    type: SET_EXECUTORS,
    payload,
  };
};

export const setUsersPaginationAmountAC = (amount) => {
  return {
    type: SET_USERS_PAGINATION_AMOUNT,
    payload: amount,
  };
};

export const usersSetSelectedUserAC = (id) => {
  return {
    type: SET_SELECTED_USER,
    payload: id,
  };
};

export const usersSetAdminSectionLimitAC = (amount) => {
  return {
    type: SET_USERS_LIMIT,
    payload: amount,
  };
};
